import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Collapse } from 'reactstrap';
import classNames from 'classnames';
var blockClass = 'collapse-panel';

var CollapsePanel = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CollapsePanel, _React$Component);

  function CollapsePanel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isCollapsed: props.isCollapsed
    };
    return _this;
  }

  var _proto = CollapsePanel.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        triggerContent = _this$props.triggerContent,
        triggerClassName = _this$props.triggerClassName,
        panelClassName = _this$props.panelClassName,
        panelContent = _this$props.panelContent,
        id = _this$props.id,
        isEnabled = _this$props.isEnabled,
        icon = _this$props.icon,
        iconPosition = _this$props.iconPosition,
        showIcon = _this$props.showIcon;
    var isCollapsed = this.state.isCollapsed;
    var classes = classNames(blockClass, className, isEnabled ? blockClass + "--enabled" : '', isCollapsed ? blockClass + "--collapsed" : '');
    var triggerClasses = classNames(blockClass + "__trigger", showIcon ? blockClass + "__trigger--icon-" + iconPosition : '', triggerClassName);
    var panelClasses = classNames(blockClass + "__panel", panelClassName);
    return /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement("div", {
      className: triggerClasses,
      "aria-expanded": !isCollapsed,
      "aria-controls": id,
      role: "button",
      onClick: function onClick() {
        return isEnabled && _this2.setState({
          isCollapsed: !isCollapsed
        });
      }
    }, triggerContent, showIcon && isEnabled && /*#__PURE__*/React.createElement("div", {
      className: blockClass + "__icon"
    }, icon || /*#__PURE__*/React.createElement("span", {
      className: "arrow-angle " + (isCollapsed ? 'arrow-angle--right' : 'arrow-angle--down')
    }))), /*#__PURE__*/React.createElement(Collapse, {
      id: id,
      className: panelClasses,
      isOpen: !isEnabled || !isCollapsed
    }, panelContent));
  };

  return CollapsePanel;
}(React.Component);

export { CollapsePanel as default };
CollapsePanel.defaultProps = {
  isEnabled: true,
  isCollapsed: false,
  iconPosition: 'right',
  showIcon: true
};